var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 496,
    viewBox: "0 0 403 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M402.181 249.42C395.181 245.342 390.11 245.231 386.969 249.089C383.827 252.892 382.284 259.341 382.284 268.435V317.433C382.284 326.748 381.402 334.464 379.693 340.582C377.985 346.92 375.064 351.44 371.04 354.085C367.127 356.786 361.836 357.502 355.112 356.235C348.553 355.022 340.341 351.605 330.53 345.928L325.845 343.227V304.646L331.687 308.008C338.687 312.087 343.372 312.583 345.742 309.607C348.222 306.741 349.49 300.733 349.49 291.639V248.483C349.49 237.24 350.592 228.366 352.797 221.807C355.002 215.248 359.356 211.115 365.914 209.241C359.356 199.816 355.002 190.611 352.797 181.572C350.592 172.533 349.545 162.392 349.545 151.149V107.993C349.545 98.8986 348.277 91.5131 345.797 85.7259C343.482 80.049 338.797 75.1988 331.743 71.1202L325.9 67.7581V29.177L330.585 31.8777C340.396 37.5546 348.608 43.5623 355.167 49.9557C361.891 56.4043 367.182 63.2937 371.095 70.5139C375.174 77.8443 378.04 85.6708 379.749 93.9933C381.457 102.095 382.339 110.859 382.339 120.118V169.116C382.339 178.21 383.882 186.478 387.024 193.863C390.165 201.304 395.236 207.036 402.236 211.059L402.181 249.42Z",
    fill: "url(#paint0_linear_437_2474)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M224.432 107.496C231.432 111.575 236.502 111.685 239.644 107.827C242.786 104.024 244.329 97.5756 244.329 88.4815V39.4835C244.329 30.1689 245.211 22.4526 246.919 16.3348C248.628 9.99645 251.439 5.42183 255.352 2.72115C259.431 0.0755874 264.722 -0.640919 271.281 0.571631C278.005 1.8393 286.272 5.3116 296.083 10.9885L300.768 13.6892V52.2703L294.925 48.9083C287.926 44.8297 283.131 44.2785 280.65 47.1446C278.335 50.1208 277.123 56.1285 277.123 65.2226V108.378C277.123 119.622 276.021 128.496 273.816 135.054C271.611 141.558 267.257 145.747 260.698 147.621C267.257 157.046 271.611 166.25 273.816 175.289C276.021 184.328 277.068 194.469 277.068 205.713V248.869C277.068 257.963 278.225 265.348 280.595 271.025C283.075 276.813 287.87 281.718 294.87 285.741L300.712 289.103V327.685L296.028 324.984C286.217 319.307 277.95 313.244 271.225 306.796C264.667 300.402 259.376 293.568 255.297 286.237C251.384 279.017 248.573 271.246 246.864 262.868C245.156 254.766 244.274 246.003 244.274 236.743V187.745C244.274 178.651 242.731 170.384 239.589 162.998C236.447 155.558 231.377 149.826 224.377 145.802L224.432 107.496Z",
    fill: "url(#paint1_linear_437_2474)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M380.134 265.955C373.135 261.876 368.064 261.766 364.922 265.624C361.781 269.427 360.238 275.876 360.238 284.97V333.968C360.238 343.282 359.356 350.999 357.647 357.117C355.938 363.455 353.017 367.974 348.994 370.62C345.081 373.321 339.789 374.037 333.065 372.769C326.507 371.557 318.294 368.14 308.484 362.463L303.799 359.762V321.181L309.641 324.543C316.641 328.622 321.326 329.118 323.696 326.141C326.176 323.275 327.444 317.268 327.444 308.174V265.018C327.444 253.774 328.546 244.901 330.751 238.342C332.955 231.783 337.309 227.649 343.868 225.775C337.309 216.351 332.955 207.146 330.751 198.107C328.546 189.068 327.499 178.927 327.499 167.683V124.527C327.499 115.433 326.231 108.048 323.751 102.261C321.436 96.5836 316.751 91.7334 309.696 87.6549L303.854 84.2928V45.7117L308.539 48.4123C318.349 54.0893 326.562 60.0969 333.12 66.4904C339.845 72.9389 345.136 79.8284 349.049 87.0486C353.128 94.379 355.994 102.205 357.702 110.528C359.411 118.63 360.293 127.393 360.293 136.653V185.651C360.293 194.745 361.836 203.012 364.977 210.398C368.119 217.839 373.19 223.571 380.189 227.594L380.134 265.955Z",
    fill: "url(#paint2_linear_437_2474)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M202.385 124.031C209.385 128.11 214.456 128.22 217.597 124.362C220.739 120.559 222.282 114.11 222.282 105.016V56.0181C222.282 46.7035 223.164 38.9873 224.873 32.8694C226.581 26.5311 229.392 21.9565 233.305 19.2558C237.384 16.6103 242.675 15.8937 249.234 17.1063C255.958 18.374 264.225 21.8463 274.036 27.5232L278.721 30.2239V68.805L272.879 65.4429C265.879 61.3644 261.084 60.8132 258.604 63.6792C256.289 66.6555 255.076 72.6631 255.076 81.7573V124.913C255.076 136.157 253.974 145.03 251.769 151.589C249.565 158.093 245.21 162.282 238.652 164.156C245.21 173.58 249.565 182.785 251.769 191.824C253.974 200.863 255.021 211.004 255.021 222.248V265.403C255.021 274.498 256.179 281.883 258.549 287.56C261.029 293.347 265.824 298.253 272.824 302.276L278.666 305.638V344.219L273.981 341.518C264.17 335.842 255.903 329.779 249.179 323.33C242.62 316.937 237.329 310.102 233.25 302.772C229.337 295.552 226.526 287.78 224.818 279.403C223.109 271.301 222.227 262.537 222.227 253.278V204.28C222.227 195.186 220.684 186.918 217.542 179.533C214.401 172.092 209.33 166.36 202.33 162.337L202.385 124.031Z",
    fill: "url(#paint3_linear_437_2474)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M80.0285 6.74463L174.222 61.144L174.166 286.733L79.9734 232.334L80.0285 6.74463Z",
    fill: "url(#paint4_linear_437_2474)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3362 41.4126L137.239 84.6786V105.457L62.3362 62.1913V41.4126Z",
    fill: "#5F27BD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M91.6577 131.582L163.639 173.139V205.437L91.6577 163.88V131.582Z",
    fill: "#EEF0EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M91.6025 92.5049L163.694 134.117V141.613L91.6025 100.056V92.5049Z",
    fill: "#EEF0EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M91.6025 107.166L153.939 143.156V150.652L91.6025 114.662V107.166Z",
    fill: "#EEF0EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M80.0283 6.74463L174.221 61.144V91.4027L80.0283 37.0033V6.74463Z",
    fill: "url(#paint5_linear_437_2474)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.563 35.6255C103.563 40.2001 100.862 42.3496 97.5551 40.4757C94.2481 38.5466 91.6025 33.3106 91.6025 28.736C91.6025 24.1614 94.3032 22.0119 97.6102 23.8858C100.862 25.8149 103.563 31.0509 103.563 35.6255Z",
    fill: "#EEF0EC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M195.771 215.909L289.965 270.309L289.909 495.898L195.716 441.499L195.771 215.909Z",
    fill: "url(#paint6_linear_437_2474)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.652 281.552L306.555 324.763V345.487L231.597 302.276L231.652 281.552Z",
    fill: "url(#paint7_linear_437_2474)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M207.401 302.993L279.438 344.605V376.848L207.401 335.235V302.993Z",
    fill: "#EEF0EC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M207.291 349.07L279.383 390.682V398.178L207.291 356.62V349.07Z",
    fill: "#EEF0EC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M207.291 362.628L269.627 398.619V406.114L207.291 370.124V362.628Z",
    fill: "#EEF0EC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M195.772 215.909L289.965 270.309V300.567L195.772 246.168V215.909Z",
    fill: "url(#paint8_linear_437_2474)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M219.306 244.845C219.306 249.42 216.605 251.569 213.298 249.695C209.992 247.766 207.346 242.53 207.346 237.956C207.346 233.381 210.047 231.232 213.354 233.106C216.605 234.979 219.306 240.271 219.306 244.845Z",
    fill: "#EEF0EC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M179.457 247.16L15.4875 152.526L15.5427 238.011L165.072 324.322L179.568 345.762L179.457 247.16Z",
    fill: "url(#paint9_linear_437_2474)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M137.293 243.633L101.358 222.909V230.405L137.293 251.129V243.633Z",
    fill: "#EEF0EC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M137.294 258.679L48.3367 207.311V214.807L137.349 266.175L137.294 258.679Z",
    fill: "#EEF0EC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M137.349 273.726L29.928 211.721V219.216L137.349 281.222V273.726Z",
    fill: "#EEF0EC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.167 256.585C146.167 263.64 150.356 271.742 155.482 274.718C160.608 277.694 164.797 274.387 164.797 267.333C164.797 260.278 160.608 252.176 155.482 249.199C150.301 246.223 146.167 249.53 146.167 256.585Z",
    fill: "#D171CE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M31.6917 92.505L9.97607 79.9386V72.6082L31.6917 85.1746C33.4555 86.2218 36.0459 88.2611 38.2505 91.4578C40.6205 94.875 42.3291 99.174 42.3291 103.859C42.3291 109.04 41.0063 111.961 38.5261 112.843C36.1561 113.614 33.4003 112.292 31.6917 111.3L22.763 106.119L22.7078 106.064C21.9362 105.623 20.7237 105.182 19.7867 105.457C19.0151 105.678 18.0781 106.504 18.0781 109.37C18.0781 112.236 18.96 114 19.7316 115.047C20.6686 116.37 21.8811 117.307 22.6527 117.693L22.763 117.748L50.1004 133.511V140.842L22.9283 125.134C21.0544 124.142 18.3537 122.102 16.0388 118.85C13.5035 115.268 11.7398 110.748 11.7398 105.678C11.7398 100.662 13.5035 98.0717 15.9837 97.3552C18.2986 96.6938 20.9993 97.6859 22.8732 98.7882L31.7469 103.914C33.0145 104.63 34.0066 104.961 34.6129 104.741C35.1089 104.575 35.9908 103.859 35.9908 100.166C35.9908 97.741 35.2192 96.1978 34.4475 95.0954C33.5657 93.8829 32.4082 92.8908 31.6917 92.505Z",
    fill: "#EEF0EC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4245 80.7101C16.4245 86.9933 12.7318 89.9144 8.21227 87.324C3.69277 84.7335 0 77.5134 0 71.2301C0 64.9469 3.69277 62.0258 8.21227 64.6162C12.7318 67.2618 16.4245 74.482 16.4245 80.7101ZM59.9661 141.338C59.9661 147.621 56.2733 150.542 51.7538 147.951C47.2343 145.361 43.5416 138.141 43.5416 131.858C43.5416 125.574 47.2343 122.653 51.7538 125.244C56.2733 127.889 59.9661 135.109 59.9661 141.338Z",
    fill: "#46F3B5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M118.554 332.975C121.861 334.905 124.507 339.479 124.507 343.337V360.148L135.64 366.541C138.947 368.47 141.593 373.045 141.593 376.903C141.593 380.706 138.892 382.249 135.64 380.375L124.507 373.982V390.792C124.507 394.595 121.806 396.138 118.554 394.264C115.247 392.335 112.602 387.761 112.602 383.903V367.092L101.468 360.699C98.1612 358.77 95.5156 354.195 95.5156 350.337C95.5156 346.534 98.2163 344.991 101.468 346.865L112.602 353.258V336.448C112.602 332.59 115.247 331.046 118.554 332.975Z",
    fill: "url(#paint10_linear_437_2474)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_437_2474",
    x1: 4541.08,
    y1: 1142.58,
    x2: -5843.95,
    y2: 19140.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_437_2474",
    x1: 4635.78,
    y1: 158.272,
    x2: -5747.23,
    y2: 18153.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_437_2474",
    x1: 4519.03,
    y1: 1159.12,
    x2: -5865.99,
    y2: 19157.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_437_2474",
    x1: 4613.74,
    y1: 174.806,
    x2: -5769.28,
    y2: 18169.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_437_2474",
    x1: 5345.9,
    y1: 5543.24,
    x2: -1658.91,
    y2: 17678.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_437_2474",
    x1: 3312.92,
    y1: 857.219,
    x2: 5689.63,
    y2: 7596.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_437_2474",
    x1: 5461.65,
    y1: 5752.13,
    x2: -1543.22,
    y2: 17887.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_437_2474",
    x1: 269.076,
    y1: 281.552,
    x2: 269.076,
    y2: 345.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46F3B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_437_2474",
    x1: 3429.04,
    y1: 1067.32,
    x2: 5805.74,
    y2: 7806.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_437_2474",
    x1: 11550.2,
    y1: 6197.34,
    x2: 4546.42,
    y2: 11681.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_437_2474",
    x1: 3017.94,
    y1: 2567.29,
    x2: 956.527,
    y2: 4193.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHero);
export default __webpack_public_path__ + "static/media/img_hero.ce41e3a58f9b38c87a5f0d92b9c2bd7e.svg";
export { ForwardRef as ReactComponent };